const options = {
	//Hold a11yId constant if in testing mode
	testing: false
};

import ScreenReaderText from './components/screen-reader-text';
import withAriaId from './components/with-aria-id';

export {
	options,
	ScreenReaderText,
	withAriaId
};
